import PurchaseWithConfidenceContainer from './PurchaseWithConfidenceContainer';

export default PurchaseWithConfidenceContainer;
